import Alpine from '../../../../CodeQ.Site/Resources/Private/Fusion/node_modules/alpinejs'
import General from '../../../../CodeQ.Site/Resources/Private/Fusion/javascript/general';

/**
 * Validates the CodeQ.CamBuildr:Mixin.Form.ParticipateField required option
 */
Alpine.data('cambuildrForm', () => ({

    updateParticipateFieldStatus(e) {
        this.validateParticipateFields();
    },

    validateParticipateFields(showNewErrorMessages = false) {
        let valid = true;
        let firstErrorElement = null;
        this.$root.querySelectorAll('.participate-field--is-required').forEach((element) => {
            if (!element.querySelector('input[type="checkbox"]:checked')) {
                valid = false;
                if (showNewErrorMessages) {
                    firstErrorElement = firstErrorElement || element;
                    element.querySelector('.participate-field__required-error').classList.remove('hidden');
                }
            } else {
                element.querySelector('.participate-field__required-error').classList.add('hidden');
            }
        });
        if (firstErrorElement) {
            General.scrollTo(firstErrorElement);
        }
        console.info('validateParticipateFields', valid);
        return valid;
    },

    validateForm(e) {
        if (!this.validateParticipateFields(true)) {
            e.preventDefault();
        }
    }
}));
